<template>
  <div id="homework-week" class="view-container">
    <BottomBar />
    <div v-if="!data">
      <Empty
        :loading="isLoading"
        :error="error"
        :icon="true"
        title="暂无作业"
        subtitle="该周没有布置作业"
        link="/homework"
        link-text="查看更多"
      />
    </div>
    <div v-else>
      <main class="padding-y items">
        <Top :start="$moment(start)" :end="$moment(end)" :homework="homework" />
        <Item
          v-for="item in homework"
          :key="item.id"
          :data="item"
          :schedule="schedule.find(s => s.id === item.schedule_time.s_id)"
          :teacher="teacher.find(t => item.schedule_time.t_id === t.t_id)"
        />
      </main>
      <router-link class="text-center block" to="/homework?tab=1">查看更多作业</router-link>
    </div>
  </div>
</template>
<script>
import Item from "../Item"
import Top from "./Top"

export default {
  name: "HomeworkWeek",
  components: {
    Item,
    Top
  },
  data() {
    return {
      data: undefined,
      isLoading: true,
      error: null,
    }
  },
  computed: {
    start() {
      return this.$route.query.start
    },
    end() {
      return this.$route.query.end
    },
    homework() {
      if (!this.data) return []
      return this.data.homework
    },
    teacher() {
      if (!this.data) return []
      return this.data.teacher
    },
    schedule() {
      if (!this.data) return []
      return this.data.schedule
    },
  },
  created() {
    this.wechatInit()
    this.getData()
  },
  methods: {
    wechatInit() {
      this.$wxShare({
        title: "课后作业 - AnyTeach",
        imgUrl: window.logo2019,
        desc: "点击查看你的课后作业，记得按时完成！",
        link: window.homePageUrl + this.$route.fullPath,
      })
    },
    async getData() {
      try {
        const { code, msg } = await this.$api.homework.LIST({ start: this.start, end: this.end })
        this.isLoading = false
        if (code === "1000") {
          this.data = msg
        } else {
          this.data = false
        }
      } catch (error) {
        this.isLoading = false
        this.error = error.message
      }
    },
  },
}
</script>
<style scoped lang="scss">
@import "../style.scss";
@import "@/assets/css/scaffold.scss";
#homework-week {
  a {
    font-size: 0.9rem;
  }
}
</style>
